import * as z from 'zod'
import { PageFormValues } from './types'

/**
 * Zod schema for the page settings form.
 *
 * Extracted out of the (now removed) drawer-based `PageForm` so that the
 * dedicated `/pages/:id` editor components (`PageDetails`, `PageSettingsPanel`)
 * can share the exact same validation rules.
 */
export const pageFormSchema = z.object({
  code: z
    .string()
    .min(1, 'Code is required')
    .regex(/^[a-z0-9-]+$/, 'Code must be lowercase alphanumeric with hyphens only'),
  published: z.boolean(),
  chromeless: z.boolean(),
  private: z.boolean(),
  arrangement: z.number().int().min(0),
  hero_imageId: z.number().int().nullable().optional(),
  hero_display: z.enum(['full_width', 'content_width', 'none']).optional(),
  hero_height_value: z.number().int().positive().nullable().optional(),
  hero_height_unit: z.enum(['px', 'vh']).optional(),
  hero_video_link: z.string().nullable().optional(),
  parentId: z.string().nullable().optional(),
  page_profiles: z
    .array(
      z.object({
        id: z.string().optional(),
        language: z.string(),
        slug: z.string().optional(),
        title: z.string().optional(),
        subtitle: z.string().optional(),
        meta_description: z.string().optional(),
        cta_label: z.string().optional(),
        cta_link: z.string().optional(),
      })
    )
    .refine(
      items => items.some(item => item.title?.trim() !== '' && item.slug?.trim() !== ''),
      { message: 'At least one language must have title and slug filled' }
    ),
  tag_ids: z.array(z.number()).optional().default([]),
  cta_new_tab: z.boolean().optional(),
  cta_link_page_id: z.string().nullable().optional(),
  cta_link_type: z.enum(['cms_page', 'category', 'store']).nullable().optional(),
  cta_link_category_id: z.number().nullable().optional(),
}) satisfies z.ZodType<PageFormValues>
